import { Component, OnInit} from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.css'],
    standalone: false
})
export class SessionExpiredComponent implements OnInit{

  constructor(
    private authService: AuthService
  ) { }


  ngOnInit() {
    this.authService.logout();
  }
}
